var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAsset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50 -296)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(50 296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 295.973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.491,27.285H1.43A.423.423,0,0,0,1,27.7H1v11.7a.423.423,0,0,0,.429.418H18.47a.418.418,0,1,0,0-.836H1.859V28.121h24.2v1.045a.423.423,0,0,0,.429.418h0a.423.423,0,0,0,.43-.417h0V27.7A.423.423,0,0,0,26.491,27.285Z",
    transform: "translate(0 -17.119)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.414,13.723,5.366,9.334a.441.441,0,0,0-.324.055.421.421,0,0,0-.189.262l-1,4.389a.418.418,0,0,0,.326.5.43.43,0,0,0,.513-.317l.909-3.98,19.628,4.3a.417.417,0,0,0,.095.01.417.417,0,0,0,.094-.826Z",
    transform: "translate(-1.838 -5.368)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.072,5.936,21.043,1.059a.436.436,0,0,0-.551.2l-1,1.951a.414.414,0,0,0,.174.568.437.437,0,0,0,.584-.169l.013-.024h0l.822-1.6L32.74,6.709a.435.435,0,0,0,.563-.225A.415.415,0,0,0,33.072,5.936Z",
    transform: "translate(-11.93)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.851,32.812H46.873a.418.418,0,1,0,0,.836h3.978a.418.418,0,1,0,0-.836Z",
    transform: "translate(-29.404 -20.655)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.213,32.891a4.293,4.293,0,1,0,4.411,4.291A4.352,4.352,0,0,0,28.213,32.891Zm0,7.8a3.512,3.512,0,1,1,3.609-3.511A3.561,3.561,0,0,1,28.213,40.693Z",
    transform: "translate(-14.755 -20.741)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.271,36.759c-2.656,0-5.513.611-5.513,1.951v11.7c0,1.34,2.857,1.951,5.513,1.951s5.513-.611,5.513-1.951V38.71C65.784,37.37,62.927,36.759,60.271,36.759Zm4.511,13.647c-.076.271-1.579.983-4.511.983s-4.435-.712-4.511-.975v-.767a11.317,11.317,0,0,0,4.511.767,11.35,11.35,0,0,0,4.511-.767Zm0-1.951c-.076.271-1.579.983-4.511.983s-4.435-.712-4.511-.975V47.7a11.317,11.317,0,0,0,4.511.767,11.35,11.35,0,0,0,4.511-.767Zm0-1.951c-.076.271-1.579.983-4.511.983s-4.435-.712-4.511-.975v-.767a11.317,11.317,0,0,0,4.511.767,11.35,11.35,0,0,0,4.511-.767Zm0-1.951c-.076.271-1.579.983-4.511.983s-4.435-.712-4.511-.975V43.8a11.317,11.317,0,0,0,4.511.767,11.35,11.35,0,0,0,4.511-.767Zm0-1.951c-.076.271-1.579.983-4.511.983s-4.435-.712-4.511-.975v-.767a11.36,11.36,0,0,0,4.511.767,11.349,11.349,0,0,0,4.511-.767Zm0-1.951c-.076.271-1.579.983-4.511.983s-4.435-.712-4.511-.975v-.767a11.36,11.36,0,0,0,4.511.767,11.35,11.35,0,0,0,4.511-.767Zm-4.511-.968c-2.928,0-4.43-.71-4.511-.967v0c.081-.272,1.583-.981,4.511-.981,2.907,0,4.411.7,4.511.975C64.682,38.986,63.178,39.685,60.271,39.685Z",
    transform: "translate(-34.784 -23.337)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.124,40.614H9.336L7.539,38.7v-3.17l1.984-1.885h3.6a.418.418,0,1,0,0-.836H9.349a.436.436,0,0,0-.3.119L6.809,35.055a.516.516,0,0,0-.129.341v3.468a.412.412,0,0,0,.112.282l2.036,2.167a.435.435,0,0,0,.317.136h3.979a.418.418,0,1,0,0-.836Z",
    transform: "translate(-3.675 -20.691)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.789,40.538h-.5c-.156,0-.251-.085-.251-.122s.095-.122.251-.122h1.253a.488.488,0,1,0,0-.975h-.5a.5.5,0,0,0-1,0v.022a1.148,1.148,0,0,0-1,1.073,1.185,1.185,0,0,0,1.253,1.1h.5c.156,0,.251.085.251.122s-.095.122-.251.122H32.536a.488.488,0,1,0,0,.975h.5a.5.5,0,0,0,1,0v-.022a1.148,1.148,0,0,0,1-1.073A1.185,1.185,0,0,0,33.789,40.538Z",
    transform: "translate(-20.081 -24.583)",
    fill: "#006"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAsset);
export default __webpack_public_path__ + "static/media/icon-asset.42f449f99936ed7f9835231d75f7454a.svg";
export { ForwardRef as ReactComponent };